import { DAIMI_AL_INTRO, DAIMI_AL_SLUG } from '@/content/daimiAirlines'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The first report whose own copy was supplied — read off the screenshot of
  // the live page, verbatim, rather than paraphrased — and the sixth with a
  // designed page of its own, asked for on 2026-08-27 (*"airlines
  // focusreport"*) with a full-page screenshot of the live page, the cover at
  // 2560px, the vitality chart and the report mockup. See
  // `content/daimiAirlines.ts` and `pages/DaimiAirlines.tsx`.
  ...focus(
    DAIMI_AL_SLUG,
    'Airlines',
    'daimi-report-2026-airlines-cover',
    '1d62f703-e2b2-405b-94a4-500a4c5f6dd0-digitopia-daimi-2026-report-airlines.pdf',
  ),
  // The supplied paragraphs, which used to be written out here and now live on
  // the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_AL_INTRO.body,
  layout: 'airlines-focus',
  // Its own words, its cover, its file and now both of its figures — the one
  // report with no gap left to annotate, so `stillToCome` has nothing to say
  // about it. What is still open about it is section-by-section on its page,
  // and `daimiAirlinesChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 4
